export default function BatonRougeAcceptanceFacilitiesSection() {
  const facilities = [
    {
      name: "Baton Rouge Main Post Office",
      address: "750 Florida Blvd, Baton Rouge, LA 70801",
      hours: "Mon–Fri 8:30 AM – 5:00 PM (appointment required)",
      phone: "(225) 346-7614",
      notes: "Passport acceptance services available by appointment. Photo services on-site. Central location in downtown Baton Rouge near the State Capitol.",
    },
    {
      name: "Siegen Lane Post Office",
      address: "10200 Siegen Ln, Baton Rouge, LA 70810",
      hours: "Mon–Fri 9:00 AM – 4:00 PM, Sat 9:00 AM – 12:00 PM",
      phone: "(225) 767-1220",
      notes: "Convenient for south Baton Rouge and LSU-area residents. Passport photos available. Call ahead for Saturday availability.",
    },
    {
      name: "Zachary Post Office",
      address: "4503 Main St, Zachary, LA 70791",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(225) 654-5558",
      notes: "Serves Zachary, Baker, and north Baton Rouge residents. Smaller facility — appointments fill quickly in spring and summer.",
    },
    {
      name: "Port Allen Post Office",
      address: "415 Court St, Port Allen, LA 70767",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(225) 344-6220",
      notes: "Primary acceptance facility for West Baton Rouge Parish residents. Convenient for petrochemical corridor workers on the west bank.",
    },
  ];

  return (
    <section id="acceptance-facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Passport Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where to Submit a New Passport in Baton Rouge
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            First-time applicants and minors must visit an acceptance clerk in person to submit their application. Baton Rouge-area residents can use these facilities — though most travelers using Fast Passport Center ship documents directly to us after their clerk visit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {facilities.map((f, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
                  <i className="ri-map-pin-2-line text-[#1A365D] text-base"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{f.name}</h3>
                  <p className="text-gray-500 text-xs mt-0.5">{f.address}</p>
                </div>
              </div>
              <div className="space-y-1.5 text-xs text-gray-500 ml-12">
                <p><i className="ri-time-line text-[#F6C344] mr-1"></i>{f.hours}</p>
                <p><i className="ri-phone-line text-[#F6C344] mr-1"></i>{f.phone}</p>
              </div>
              <div className="mt-3 ml-12 bg-white rounded-md p-3 border border-gray-200">
                <p className="text-gray-500 text-xs leading-relaxed">{f.notes}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-6 flex flex-col md:flex-row items-center gap-5 text-center md:text-left">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-lightbulb-line text-[#1A365D] text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="text-white font-bold text-base mb-1">How This Works With Fast Passport Center</p>
            <p className="text-white/60 text-sm leading-relaxed">
              Visit the clerk with your sealed envelope, then ship it overnight to Fast Passport Center for expedited processing. We handle the rest — no need to wait for standard mail timelines or drive to Houston for a passport agency appointment.
            </p>
          </div>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0"
          >
            Start Now <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}